import { Button, Col, Divider, Input, Row, Spin } from "antd";
import { APP_ROUTES, MAIN_ROUTES } from "../../../../_config/routes";
import { Link } from "react-router-dom";
import { useDspatchByClientDate } from "../../../../hooks/orders/useDespatchByClientDate.hook";
import TableGroupDepartures from "../info_order_client_general/departures_client/table";

export default function DeparturesClientDate(){
    
    const hook = useDspatchByClientDate()
    
    if(hook.loading) return(<Spin />);
    return(
        <Row>
            <Col xs={2} lg={2}>
                <Link to={`${MAIN_ROUTES.app_modules}${APP_ROUTES.departures_history}`}>
                    Atras
                </Link>
            </Col>
            <Col lg={12} xs={22}>
                <div style={{ margin: '20px 10px', fontSize: '1.1em', fontWeight: 'bold'}}>Despachos {hook.data.length > 0 ? hook.data[0].client_name : ''}</div>
            </Col>
            <Col lg={24} xs={24}>
                <Divider />
            </Col>
            <Col lg={24} xs={24}>
            {
                hook.loading &&
                <Spin />
            }
            </Col>
            <Col lg={24} xs={24}>
                <div style={{width: '100%' }}>
                <TableGroupDepartures detailsGroup={hook.data} />
                </div>
            </Col>
        </Row>   
    );
}